import React from 'react';

function Footer() {
  return (
    <footer className="py-5 bg-black">
      <div className="container px-5"><p className="m-0 text-center text-white small">Copyright &copy; Phantom Xerox Pvt. Ltd. 2024</p></div>
    </footer>
  );
}

export default Footer;
